import React, { useState } from 'react';
import { connect } from 'redux-scaffolding-ts';
import { EventFormStore, EventFormViewModel, EventSupportDetailsViewModel } from 'stores/events/event-form-store';
import TailwindNewEventsSupportDetails from './tailwind-new-support-details.component';
import TailwindSupportDetails from './tailwind-support-details.component';

interface EventSupportDetailsContainerProps {
  event?: EventFormViewModel;
  eventFormStore?: EventFormStore;
  readOnly: boolean;
  isHideEditButton: boolean;
}
const EventSupportDetailsContainer: React.FC<EventSupportDetailsContainerProps> = ({
  event,
  eventFormStore,
  readOnly,
  isHideEditButton
}) => {
  const [selectedEvent, setSelectedEvent] = useState<EventFormViewModel>(event);

  const handleOnStudentsChange = (supportDetails: EventSupportDetailsViewModel) => {
    const eventCopy = { ...selectedEvent };
    setSelectedEvent({ ...eventCopy, supportDetails });
    eventFormStore.change({ supportDetails });
  };

  return (
    <div className="space-y-4">
      {!selectedEvent.supportDetails?.isNewSupportPositionModel && (
        <TailwindSupportDetails
          event={selectedEvent}
          supportDetails={selectedEvent.supportDetails}
          onChange={data => handleOnStudentsChange(data)}
          readonly={readOnly}
          isHideEditButton={isHideEditButton}
          eventFormStore={eventFormStore}
        />
      )}
      {selectedEvent.supportDetails?.isNewSupportPositionModel && (
        <TailwindNewEventsSupportDetails
          supportDetails={selectedEvent.supportDetails}
          onChange={data => handleOnStudentsChange(data)}
          readonly={readOnly}
          isHideEditButton={isHideEditButton}
          eventFormStore={eventFormStore}
          event={selectedEvent}
        />
      )}
    </div>
  );
};

export default connect(['eventFormStore', EventFormStore])(EventSupportDetailsContainer);
